/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_A4Inputs */

const en_guide_what_is_json_faq_a4 = /** @type {(inputs: Guide_What_Is_Json_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Keys and string values are case sensitive, so "Name" and "name" are treated as two different keys. Most APIs settle on one convention, usually camelCase, and stick to it.`)
};

const ko_guide_what_is_json_faq_a4 = /** @type {(inputs: Guide_What_Is_Json_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 키와 문자열 값은 대소문자를 구분하므로 "Name"과 "name"은 서로 다른 키로 취급됩니다. 대부분의 API는 보통 camelCase 하나로 통일해 사용합니다.`)
};

const ja_guide_what_is_json_faq_a4 = /** @type {(inputs: Guide_What_Is_Json_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。キーと文字列の値は大文字と小文字を区別するため、"Name" と "name" は別のキーとして扱われます。多くの API は通常 camelCase の一つの規則に統一しています。`)
};

/**
* | output |
* | --- |
* | "Yes. Keys and string values are case sensitive, so \"Name\" and \"name\" are treated as two different keys. Most APIs settle on one convention, usually camelCase..." |
*
* @param {Guide_What_Is_Json_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_a4 = /** @type {((inputs?: Guide_What_Is_Json_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_a4(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_a4(inputs)
	return ja_guide_what_is_json_faq_a4(inputs)
});